import _ from 'underscore';
import $ from 'jquery';
import Sortable from 'sortablejs';
import Cache from 'root/cache';
import UI from 'root/ui';
import Modal from 'root/module/modal';
import Modals from 'root/modals';
import Util from 'root/module/util';
import Form from 'root/module/form';
import Svg_Icon from 'root/module/svg_icon';
import Lang from 'root/module/widget_translation';
import View from 'view/base';
import View_Form_Edit from 'view/widget_studio/form_edit';

export default View.extend({
    main_tab_selected: '#components',
    child_tab_selected: '#form', // #form #success
    form_selected: '', // default edit form

    language_code: {
        'et'    : 'eesti',
        'cs'    : 'Čeština',
        'cr'    : 'Crnogorski',
        'en'    : 'English',
        'es'    : 'Español',
        'da'    : 'Danish',
        'de'    : 'Deutsch',
        'fi'    : 'Suomi',
        'fr'    : 'Français',
        // Icelandic
        'is'    : 'Íslenska',
        'it'    : 'Italiano',
        'jp'    : '日本語',
        'ko'    : '한국어',
        'lt'    : 'lietuvių',
        'lv'    : 'Latviešu',
        'hu'    : 'Magyar',
        'nl'    : 'Nederlands',
        'no'    : 'norsk',
        'pl'    : 'Polski',
        'pt'    : 'Português (Portugal)',
        'pt'    : 'Português (Brasil)',
        'ro'    : 'română',
        'ru'    : 'Русский',
        'sk'    : 'Slovenčina',
        'sl'    : 'Slovenščina',
        'sv'    : 'Svenska',
        'zh-CN' : '简体中文',
        'zh-TW' : '繁体中文'
    },

    translation_mapping: {
        help_title                         : 'contact_us',
        help_message                       : 'contact_us_help',
        text_screenshot                    : 'draw_on_the_screen',
        text_screenshot_help               : 'draw_on_the_screen_help',
        text_video                         : 'capture_video',
        text_video_help                    : 'capture_video_help',
        text_general                       : 'general_feedback',
        text_general_help                  : 'general_feedback_help',
        text_report_bug                    : 'report_bug',
        text_report_bug_help               : 'report_bug_help',
        text_feature_request               : 'feature_request',
        text_feature_request_help          : 'feature_request_help',
        text_view_other                    : 'view_other_feedback',
        text_view_other_help               : 'view_other_feedback_help',
        header_text                        : 'welcome_message',
        text_portal                        : 'ideas_portal',
        text_roadmap                       : 'roadmap',
        text_announcement                  : 'announcement',
        text_feedback                      : 'feedback',
        text_feedback_type_bug             : 'feedback_type_bug',
        text_feedback_type_general         : 'feedback_type_general',
        text_feedback_type_feature_request : 'feedback_type_feature_request'
    },

    views: {
        form_edit_bug: {},
        form_edit_general: {},
        form_edit_feature_request: {},
    },

    events: {
        'click .tab-menu-main > a'                : 'onMainMenuClick',
        'click .tab-menu-child > a'               : 'onChildMenuClick',
        'click .account-upgrade'                  : 'onAccountUpgrade',
        'click .region-widget-edit .update-click' : 'onUpdateSettings', // prefix selector with "region-widget-edit" to exclude child views
        'keyup .region-widget-edit .update-keyup' : 'onUpdateSettings',
        'input .region-widget-edit .update-input' : 'onUpdateSettings',
        'click .region-widget-edit .radio-box'    : 'onSelectRadioBox',
        'click .layout-box-heading'               : 'onToggleLayoutBox',
        'click .form-edit'                        : 'onEditForm',
        'click .form-edit-cancel'                 : 'onEditFormCancel',
        'click .form-toggle'                      : 'onToggleForm',
        'click .ai-feedback-type-toggle'          : 'onToggleAI',
        'click input[name="feedback_type"]'       : 'onSelectFeedbackType',
        'click .radio-box-style'                  : 'onSelectLauncherStyle',
        'click .radio-box-position'               : 'onSelectLauncherPosition',
        'click .radio-box-widget-icon'            : 'onSelectLauncherIcon',
        'click #widget_icon_0'                    : 'onToggleLauncherIcon',
        'input input[name="video_time"]'          : 'onSelectVideoTime',
        'keyup input[name="help_link"]'           : 'onUpdateHelpLink',
        'click .icon-upload'                      : 'onUploadIcon',
        'click .icon-delete'                      : 'onDeleteIcon',
        'click .logo-upload'                      : 'onUploadLogo',
        'click .logo-delete'                      : 'onDeleteLogo',
        'click [name="direct_to_portal"]'         : 'onToggleDirectToPortal',
        'click .dropdown-language li'             : 'onSelectLanguage',
        'mouseenter .layout-box'                  : 'onMouseEnterLayoutBox',
        'mouseleave .layout-box'                  : 'onMouseLeaveLayoutBox'
    },

    dom_handlers: {
        onMainMenuClick: function(e) {
            // reset child tab
            this.$el.find('.tab-menu-child > a:first').click();
        },

        onChildMenuClick: function(e) {
            this.child_tab_selected = $(e.currentTarget).attr('href');
            this.trigger('Widget::Preview');
        },

        onAccountUpgrade: function(e) {
            Modals.choosePlan();
        },

        onToggleLayoutBox: function(e) {
            if ($(e.target).prop('tagName').toLowerCase() === 'button') {
                return;
            }

            var selected_box = $(e.currentTarget).parents('.layout-box:first');

            this.$el.find('.layout-box').not(selected_box).removeClass('layout-box-open');
            selected_box.toggleClass('layout-box-open');
        },

        onMouseEnterLayoutBox: function(e) {
            var layout_name = $(e.currentTarget).data('val');

            if (['capture', 'video', 'bug', 'general', 'feature_request', 'view_other', 'help'].indexOf(layout_name) === -1) {
                return;
            }

            this.trigger('Widget::Highlight', layout_name);
        },

        onMouseLeaveLayoutBox: function(e) {
            var layout_name = $(e.currentTarget).data('val');

            if (['capture', 'video', 'bug', 'general', 'feature_request', 'view_other', 'help'].indexOf(layout_name) === -1) {
                return;
            }

            this.trigger('Widget::Highlight', '');
        },

        onSelectFeedbackType: function(e) {
            var feedback_type = $(e.currentTarget).val();
            var is_selected = $(e.currentTarget).prop('checked');
            var num_selected = this.$el.find('input[name="feedback_type"]:checked').length;

            if (num_selected === 0) {
                $(e.currentTarget).prop('checked', true);

                Modal.open({
                    title: 'At least one feedback type',
                    content: '<p>You will need at least one feedback type for your form.</p>',
                    button: {
                        OK:  function() {
                            Modal.close();
                        }
                    }
                });
            } else {
                // disable the defaut value if the feedback type is not selected
                if (is_selected) {
                    this.$el.find('input[name="feedback_type_default"][value=""]')
                        .prop('disabled', false);

                    this.$el.find('input[name="feedback_type_default"][value="' + feedback_type + '"]')
                        .prop('disabled', false);
                } else {
                    if (num_selected === 1) {
                        this.$el.find('input[name="feedback_type_default"][value=""]')
                            .prop('disabled', true)
                            .prop('checked', false);
                    }

                    this.$el.find('input[name="feedback_type_default"][value="' + feedback_type + '"]')
                        .prop('disabled', true)
                        .prop('checked', false);

                    if (!this.$el.find('input[name="feedback_type_default"]:checked').length) {
                        this.$el.find('input[name="feedback_type_default"]').not(':disabled').eq(0).prop('checked', true);
                    }
                }
            }
        },


        onEditForm: function(e) {
            if (this.model.isNextGen()) {
                this.$el.find('.tab-menu-main > a[href="#feedback"]').click();
                return;
            }

            this.form_selected = $(e.currentTarget).parents('.layout-box:first').data('val');
            this.child_tab_selected = '#form';
            var form_name = '';

            switch (this.form_selected) {
                case 'bug':
                    form_name = 'Feedback: Bug';
                    this.views.form_edit_general.hide();
                    this.views.form_edit_feature_request.hide();
                    this.views.form_edit_bug.show();
                    this.views.form_edit_bug.goToTab('#form');
                    break;
                case 'feature_request':
                    form_name = 'Feedback: Idea';
                    this.views.form_edit_general.hide();
                    this.views.form_edit_bug.hide();
                    this.views.form_edit_feature_request.show();
                    this.views.form_edit_feature_request.goToTab('#form');
                    break;
                case 'general':
                    form_name = 'Feedback: General';
                    this.views.form_edit_bug.hide();
                    this.views.form_edit_feature_request.hide();
                    this.views.form_edit_general.show();
                    this.views.form_edit_general.goToTab('#form');
                    break;
            }

            // Show UI
            this.$el.find('.region-form-edit .form-type').text(form_name);
            this.$el.find('.region-form-edit').addClass('open');

            this.trigger('Widget::Preview');
        },

        onEditFormCancel: function(e) {
            this.form_selected = '';
            this.$el.find('.region-form-edit').removeClass('open');

            this.trigger('Widget::Preview');
        },

        onToggleAI: function(e) {
            var target = $(e.currentTarget);
            var is_on = target.hasClass('switch-off');

            if (is_on) {
                target.removeClass('switch-off').addClass('switch-on');
            } else {
                target.removeClass('switch-on').addClass('switch-off');
            }

            this.$el.find('.region-feedback-type-without-ai').toggleClass('disabled', is_on);

            this.updateWidgetSettings();
        },

        onToggleForm: function(e) {
            var layout_val = $(e.currentTarget).parents('.layout-box:first').data('val');

            // select at lease one feedback type
            if ($(e.currentTarget).hasClass('switch-on') && ['bug', 'general', 'feature_request'].indexOf(layout_val) !== -1) {
                if (this.$el.find('.layout-box[data-val="bug"], .layout-box[data-val="general"], .layout-box[data-val="feature_request"]').find('.form-toggle.switch-on').length === 1) {
                    Modal.confirm('Please select at least one feedback type.', () => {
                        Modal.close();
                    }, undefined, 'OK', 'Warning');

                    return;
                }
            }

            if ($(e.currentTarget).hasClass('switch-on')) {
                $(e.currentTarget).removeClass('switch-on').addClass('switch-off');
            } else {
                $(e.currentTarget).removeClass('switch-off').addClass('switch-on');
            }

            if (layout_val === 'help') {
                if ($(e.currentTarget).hasClass('switch-on')) {
                    if (Form.getData(this.$el.find('.region-widget-edit'), 'help_link') === '') {
                        Form.setData(this.$el.find('.region-widget-edit'), {
                            help_link: 'https://'
                        });

                        this.$el.find('input[name="help_link"]').focus();
                    }
                } else {
                    Form.setData(this.$el.find('.region-widget-edit'), {
                        help_title   : '',
                        help_message : '',
                        help_link    : ''
                    });
                }
            }

            this.updateWidgetSettings();
        },

        onUpdateSettings: function(e) {
            // wait for UI to update first (dropdown click ...etc)
            setTimeout(() => {
                this.updateWidgetSettings();
            });
        },

        onSelectRadioBox: function(e) {
            if ($(e.currentTarget).hasClass('disabled')) {
                return;
            }

            if ($(e.currentTarget).hasClass('radio-box-multiple')) {
                $(e.currentTarget).toggleClass('selected');

                if (!$(e.currentTarget).siblings('.selected').length) {
                    $(e.currentTarget).addClass('selected');
                }
            } else {
                if ($(e.currentTarget).hasClass('selected')) {
                    return;
                }

                $(e.currentTarget).parent().find('.radio-box').removeClass('selected');
                $(e.currentTarget).addClass('selected');
            }

            this.updateWidgetSettings();
        },

        onSelectLauncherStyle: function(e) {
            var style = $(e.currentTarget).data('val');

            this.$el.find('.radio-box-position').attr('data-style', style);
            this.$el.find('.region-main-button-text').toggle(style === 'text');

            this.$el.find('#widget_icon_0').prop('disabled', style === 'circle');

            if (style === 'circle' && this.$el.find('#widget_icon_0').prop('checked')) {
                this.$el.find('.radio-box-widget-icon:first').click();
            }

            this.limitLauncherOffset(true);
        },

        onSelectLauncherPosition: function(e) {
            this.limitLauncherOffset(true);
        },

        onSelectLauncherIcon: function(e) {
            this.$el.find('#widget_icon_0').prop('checked', false);
        },

        onToggleLauncherIcon: function(e) {
            var use_icon = !$(e.currentTarget).prop('checked');

            if (use_icon) {
                this.$el.find('.radio-box-widget-icon:first').addClass('selected');
            } else {
                this.$el.find('.radio-box-widget-icon').removeClass('selected');
            }

            this.updateWidgetSettings();
        },

        onSelectVideoTime: function(e) {
            var video_time = $(e.currentTarget).val();

            this.$el.find('.video-time-text > div').removeClass('selected');
            this.$el.find('.video-time-text > div[data-val="' + video_time + '"]').addClass('selected');
        },

        onSelectLanguage: function(e) {
            var language = $(e.currentTarget).data('val');

            Lang.setLang(language);

            // input placehoder
            _.each(this.translation_mapping, (translation_key, model_attribute) => {
                this.$el.find('input[name="' + model_attribute + '"]').attr('placeholder', Lang.get(translation_key));
            });

            // update model
            this.model.set('language', language);
        },

        onUpdateHelpLink: function(e) {
            var help_link = $(e.currentTarget).val();

            if (help_link) {
                this.$el.find('.layout-box[data-val="help"] .form-toggle').addClass('switch-on').removeClass('switch-off');
            } else {
                this.$el.find('.layout-box[data-val="help"] .form-toggle').addClass('switch-off').removeClass('switch-on');
            }
        },

        onUploadIcon: function(e) {
            if (!Cache.account.hasFeature('widget_branding')) {
                Modals.unlockFeature();
                return;
            }

            Util.uploadImages(1, 10, (result) => {
                if (result[0].error) {
                    UI.error(result[0].error);
                    return;
                }

                this.model.set({
                    icon_url      : result[0].content,
                    icon_url_name : result[0].name,
                    icon_url_type : result[0].type
                });

                this.$el.find('.icon-preview')
                    .attr('src', result[0].content)
                    .show();

                this.$el.find('.radio-box-widget-icon[data-val="99"]')
                    .show()
                    .click();
            });
        },

        onDeleteIcon: function(e) {
            e.stopPropagation();

            this.model.set('icon_url', '');
            this.$el.find('.radio-box-widget-icon[data-val="99"]').hide();

            this.$el.find('.radio-box-widget-icon:first').click();
        },

        onUploadLogo: function(e) {
            Util.uploadImages(1, 10, (result) => {
                if (result[0].error) {
                    UI.error(result[0].error);
                    return;
                }

                this.model.set({
                    logo      : result[0].content,
                    logo_name : result[0].name,
                    logo_type : result[0].type
                });

                this.$el.find('.logo-preview img').attr('src', result[0].content);
                this.$el.find('.logo-preview').show();
            });
        },

        onDeleteLogo: function(e) {
            e.stopPropagation();

            this.model.set('logo', '');
            this.$el.find('.logo-preview').hide();
        },

        onToggleDirectToPortal: function(e) {
            if ($(e.currentTarget).prop('checked')) {
                this.model.set('direct_to_feature_request', 'portal');
            } else {
                this.model.set('direct_to_feature_request', 'form');
            }
        }
    },

    initialize: function(options) {
        this.widget        = options.widget;
        this.model         = options.model;
        this.model_setting = options.model_setting;

        if (this.model.isNextGen()) {
            this.form_selected = 'general';
            this.main_tab_selected = '#appearance';
        }

        if (options.main_tab) {
            this.main_tab_selected = options.main_tab;
        }

        Lang.setLang(this.model.get('language'));

        this.views.form_edit_bug = new View_Form_Edit({
            widget : this.model,
            model  : this.model_setting.bug
        });
        this.views.form_edit_general = new View_Form_Edit({
            widget : this.model,
            model  : this.model_setting.general
        });
        this.views.form_edit_feature_request = new View_Form_Edit({
            widget : this.model,
            model  : this.model_setting.feature_request
        });
    },

    openComponentSettings: function(component) {
        var layout_box = this.$el.find('.layout-box[data-val="' + component + '"]');

        this.$el.find('.tab-menu-main > a[href="#components"]').click();

        if (layout_box.length && !layout_box.hasClass('layout-box-open')) {
            layout_box.find('.layout-box-heading').click();
        }
    },

    limitLauncherOffset: function(reset_to_default) {
        var widget_settings = this.getSettings();
        var default_offset = 20;

        var el_x = this.$el.find('input[name="launcher_offset_x"]');
        var el_y = this.$el.find('input[name="launcher_offset_y"]');

        this.$el.find('.region-launcher-offset-x').toggle(widget_settings.position === 'sw' || widget_settings.position === 'se');
        this.$el.find('.region-launcher-offset-y').toggle(widget_settings.style === 'circle' || widget_settings.position === 'e' || widget_settings.position === 'w');

        if (widget_settings.position === 'sw' || widget_settings.position === 'se') {
            el_x.attr('min', 0);
            el_y.attr('min', 0);
        } else {
            el_x.attr('min', 0);
            el_y.attr('min', -200);
        }

        if (el_x.val() < el_x.attr('min')) {
            el_x.val(default_offset).trigger('input');
        }

        if (el_y.val() < el_y.attr('min')) {
            el_y.val(default_offset).trigger('input');;
        }

        if (reset_to_default) {
            if (widget_settings.style === 'circle') {
                if (widget_settings.position === 'se' || widget_settings.position === 'sw') {
                    el_x.val(20);
                    el_y.val(20);
                } else {
                    el_x.val(0);
                    el_y.val(0);
                }
            } else if (widget_settings.style === 'text') {
                if (widget_settings.position === 'se' || widget_settings.position === 'sw') {
                    el_x.val(20);
                    el_y.val(0);
                } else{
                    el_x.val(0);
                    el_y.val(0);
                }
            }

            this.updateWidgetSettings();
        }
    },

    updateWidgetSettings: function() {
        var widget_settings = this.getSettings();
        this.model.set(widget_settings);
    },

    // can powered by be removed?
    canRemovePoweredBy: function() {
        return Cache.account.hasFeature('powered_by') && !Cache.account.get('is_trial');
    },

    // get widget settings from UI
    getSettings: function() {
        var form_data = Form.getData(this.$el.find('.region-widget-edit'));

        var style              = this.$el.find('.radio-box-style.selected').data('val');
        var icon               = this.$el.find('.radio-box-widget-icon.selected').data('val') || 0;
        var position           = this.$el.find('.radio-box-position.selected').data('val');
        var workflow_type      = this.model.isNextGen() ? ['general'] : [];
        var routing_item_order = [];
        var layout_options     = [];

        if (this.model.isNextGen()) {
            layout_options = ['portal', 'roadmap', 'announcement'];
        } else {
            layout_options = ['capture', 'video', 'bug', 'feature_request', 'general'];
        }

        layout_options.forEach((type) => {
            if (this.$el.find('.layout-box[data-val="' + type +  '"]').find('.form-toggle').hasClass('switch-on')) {
                workflow_type.push(type);
            }
        });

        if (!workflow_type.length) {
            workflow_type = ['general'];
        }

        this.$el.find('.sortable-container-main .layout-box').each(function() {
            routing_item_order.push($(this).data('val'));
        });

        return {
            ai_feedback_type                   : this.$el.find('.ai-feedback-type-toggle').hasClass('switch-on') ? true : false,
            workflow_type                      : workflow_type.join(','),
            feedback_type                      : form_data.feedback_type?.join(',') ?? 'general',
            feedback_type_default              : form_data.feedback_type_default || '',
            routing_item_order                 : routing_item_order.join(','),
            display_feedback                   : this.$el.find('.layout-box[data-val="view_other"]').find('.form-toggle').hasClass('switch-on'),
            style                              : style,
            icon                               : icon,
            position                           : position,
            launcher_offset_x                  : form_data.launcher_offset_x || 0,
            launcher_offset_y                  : form_data.launcher_offset_y || 0,
            header_text                        : form_data.header_text,
            use_modal                          : form_data.use_modal === 1,
            display_powered_by                 : form_data.hide_powered_by.length === 0,
            portal_target                      : form_data.portal_target || 'window',
            roadmap_target                     : form_data.roadmap_target || 'window',
            announcement_target                : form_data.announcement_target || 'window',
            help_target                        : form_data.help_target || 'window',
            main_button_text                   : form_data.main_button_text,
            main_button_background_colour      : form_data.main_button_background_colour,
            main_button_text_colour            : form_data.main_button_text_colour,
            video_time                         : form_data.video_time,
            capture_console_log                : form_data.console_log_type.indexOf('log')   !== -1,
            capture_console_error              : form_data.console_log_type.indexOf('error') !== -1,
            capture_console_warn               : form_data.console_log_type.indexOf('warn')  !== -1,
            capture_console_info               : form_data.console_log_type.indexOf('info')  !== -1,
            capture_console_debug              : form_data.console_log_type.indexOf('debug') !== -1,
            capture_network                    : form_data.console_log_type.indexOf('network') !== -1,
            capture_event                      : form_data.capture_event == 1 ? true : false,
            capture_session_recording          : form_data.capture_session_recording == 1 ? true : false,
            use_hcaptcha                       : Boolean(form_data.use_hcaptcha),
            auto_screenshot                    : form_data.auto_screenshot == 1 ? true : false,
            text_screenshot                    : form_data.text_screenshot                || '',
            text_screenshot_help               : form_data.text_screenshot_help           || '',
            text_video                         : form_data.text_video                     || '',
            text_video_help                    : form_data.text_video_help                || '',
            text_report_bug                    : form_data.text_report_bug                || '',
            text_report_bug_help               : form_data.text_report_bug_help           || '',
            text_feature_request               : form_data.text_feature_request           || '',
            text_feature_request_help          : form_data.text_feature_request_help      || '',
            text_general                       : form_data.text_general                   || '',
            text_general_help                  : form_data.text_general_help              || '',
            text_view_other                    : form_data.text_view_other                || '',
            text_view_other_help               : form_data.text_view_other_help           || '',
            text_feedback_type_bug             : form_data.text_feedback_type_bug              || '',
            text_feedback_type_general         : form_data.text_feedback_type_general          || '',
            text_feedback_type_feature_request : form_data.text_feedback_type_feature_request  || '',
            text_feedback                      : form_data.text_feedback                  || '',
            text_portal                        : form_data.text_portal                    || '',
            text_roadmap                       : form_data.text_roadmap                   || '',
            text_announcement                  : form_data.text_announcement              || '',
            help_title                         : form_data.help_title                     || '',
            help_message                       : form_data.help_message                   || '',
            help_link                          : form_data.help_link                      || '',
        };
    },

    getLayoutBox: function(value, heading, icon, turned_on, title_name, description_name, edit_form, is_retired, show_toggle, draggable) {
        var portal = Cache.portal.findWhere({project_id: this.model.get('project_id')});
        var portal_url = portal ? portal.getUrl() : '';
        var roadmap_url = portal ? portal.getUrl('roadmap') : '';
        var announcement_url = portal ? portal.getUrl('announcement') : '';

        var show_upgrade = !Cache.account.hasFeature('portal') && value === 'portal';

        var uid_direct_to = _.uniqueId(this.cid);
        var uid_portal_target_1 = _.uniqueId(this.cid);
        var uid_portal_target_2 = _.uniqueId(this.cid);
        var uid_portal_target_3 = _.uniqueId(this.cid);
        var uid_roadmap_target_1 = _.uniqueId(this.cid);
        var uid_roadmap_target_2 = _.uniqueId(this.cid);
        var uid_roadmap_target_3 = _.uniqueId(this.cid);
        var uid_announcement_target_1 = _.uniqueId(this.cid);
        var uid_announcement_target_2 = _.uniqueId(this.cid);
        var uid_announcement_target_3 = _.uniqueId(this.cid);
        var uid_help_target_1   = _.uniqueId(this.cid);
        var uid_help_target_2   = _.uniqueId(this.cid);

        var html =
        '<div class="layout-box" data-val="' + value + '">' +
            '<div class="layout-box-heading' + (this.model.isNextGen() ? '' : ' layout-box-heading-indented') + '">' +
                (this.model.isNextGen() ? '' :
                '<div class="drag-handle">' +
                    '<i class="fas fa-grip-dots-vertical"></i>' +
                '</div>') +
                '<span>' + heading + (is_retired ? '<span class="retiring tooltip" data-title="This option is being retired and will disappear after you remove it from your widget"><i class="fas fa-exclamation-circle"></i> This option is being retired</span>' : '') + '</span>' +
                '<div class="flex-c">' +
                    (show_upgrade ?
                    '<button class="account-upgrade shiny tiny" type="button"><span>UPGRADE</span></button>' : '') +
                    (edit_form ?
                    '<button type="button" class="form-edit small tertiary">Edit Form</button>' : '') +
                    '<button type="button" class="form-toggle small ' + (turned_on ? 'switch-on' : 'switch-off') + '"' + (show_toggle ? '' : ' style="display:none;"') + '></button>' +
                '</div>' +
            '</div>' +
            '<div class="layout-box-content' + (this.model.isNextGen() ? ' layout-box-content-single' : '') + '">' +
                (this.model.isNextGen() ? '' :
                '<div>' + icon + '</div>') +
                '<div>' +
                    '<input type="text" class="update-keyup solid compact" name="' + title_name + '" placeholder="' + Lang.get(this.translation_mapping[title_name], true) + '" maxlength="30">' +
                    '<input type="text" class="update-keyup solid compact" name="' + description_name + '" placeholder="' + Lang.get(this.translation_mapping[description_name], true) + '" maxlength="100"' + (this.model.isNextGen() ? ' style="display:none;"' : '') + '>' +

                    (value === 'help' ?
                    '<input type="text" class="update-keyup solid compact" name="help_link" placeholder="https://help.example.com" maxlength="200">' : '') +

                    (value === 'feature_request' ?
                    '<div class="margin-top-12">' +
                        '<input type="checkbox" name="direct_to_portal" value="1" id="' + uid_direct_to + '">' +
                        '<label for="' + uid_direct_to +'">Redirect to Portal</label>' +
                    '</div>' : '') +

                    (value === 'portal' ?
                    '<div class="margin-top-12">' +
                        '<div>' +
                            '<input type="radio" name="portal_target" class="update-click" id="' + uid_portal_target_1 + '" value="widget"><label for="' + uid_portal_target_1 + '">Embed</label>' +
                            '<div class="margin-top-8 margin-left-24">' +
                                '<a class="primary" href="https://support.userback.io/en/articles/9416861-user-database-segments" target="help" rel="noopener">Identified Users <i class="fa-solid fa-square-arrow-up-right"></i></a> will be logged in automatically' +
                            '</div>' +
                        '</div>' +
                        '<div class="divider-12"></div>' +
                        '<div><input type="radio" name="portal_target" class="update-click" id="' + uid_portal_target_2 + '" value="redirect"><label for="' + uid_portal_target_2 + '">Redirect to the <a href="' + portal_url + '" target="_blank" class="primary"><i class="fa-solid fa-link"></i> Portal</a></label></div>' +
                        '<div class="divider-12"></div>' +
                        '<div><input type="radio" name="portal_target" class="update-click" id="' + uid_portal_target_3 + '" value="window"><label for="' + uid_portal_target_3 + '">Open <a href="' + portal_url + '" target="_blank" class="primary"><i class="fa-solid fa-link"></i> Portal</a> in a new browser tab</label></div>' +
                    '</div>' : '') +

                    (value === 'roadmap' ?
                    '<div class="margin-top-12">' +
                        '<div>' +
                            '<input type="radio" name="roadmap_target" class="update-click" id="' + uid_roadmap_target_1 + '" value="widget"><label for="' + uid_roadmap_target_1 + '">Embed</label>' +
                            '<div class="margin-top-8 margin-left-24">' +
                                '<a class="primary" href="https://support.userback.io/en/articles/9416861-user-database-segments" target="help" rel="noopener">Identified Users <i class="fa-solid fa-square-arrow-up-right"></i></a> will be logged in automatically' +
                            '</div>' +
                        '</div>' +
                        '<div class="divider-12"></div>' +
                        '<div><input type="radio" name="roadmap_target" class="update-click" id="' + uid_roadmap_target_2 + '" value="redirect"><label for="' + uid_roadmap_target_2 + '">Redirect to the <a href="' + roadmap_url + '" target="_blank" class="primary"><i class="fa-solid fa-link"></i> Roadmap</a></label></div>' +
                        '<div class="divider-12"></div>' +
                        '<div><input type="radio" name="roadmap_target" class="update-click" id="' + uid_roadmap_target_3 + '" value="window"><label for="' + uid_roadmap_target_3 + '">Open <a href="' + roadmap_url + '" target="_blank" class="primary"><i class="fa-solid fa-link"></i> Roadmap</a> in a new browser tab</label></div>' +
                    '</div>' : '') +

                    (value === 'announcement' ?
                        '<div class="margin-top-12">' +
                            '<div>' +
                                '<input type="radio" name="announcement_target" class="update-click" id="' + uid_announcement_target_1 + '" value="widget"><label for="' + uid_announcement_target_1 + '">Embed</label>' +
                                '<div class="margin-top-8 margin-left-24">' +
                                    '<a class="primary" href="https://support.userback.io/en/articles/9416861-user-database-segments" target="help" rel="noopener">Identified Users <i class="fa-solid fa-square-arrow-up-right"></i></a> will be logged in automatically' +
                                '</div>' +
                            '</div>' +
                            '<div class="divider-12"></div>' +
                            '<div><input type="radio" name="announcement_target" class="update-click" id="' + uid_announcement_target_2 + '" value="redirect"><label for="' + uid_announcement_target_2 + '">Redirect to the <a href="' + announcement_url + '" target="_blank" class="primary"><i class="fa-solid fa-link"></i> Announcement</a></label></div>' +
                            '<div class="divider-12"></div>' +
                            '<div><input type="radio" name="announcement_target" class="update-click" id="' + uid_announcement_target_3 + '" value="window"><label for="' + uid_announcement_target_3 + '">Open <a href="' + announcement_url + '" target="_blank" class="primary"><i class="fa-solid fa-link"></i> Announcement</a> in a new browser tab</label></div>' +
                        '</div>' : '') +

                    (value === 'help' ?
                    '<div class="margin-top-12">' +
                        '<div>' +
                            '<input type="radio" name="help_target" class="update-click" id="' + uid_help_target_1 + '" value="redirect"><label for="' + uid_help_target_1 + '">Redirect to the link</label>' +
                        '</div>' +
                        '<div class="divider-12"></div>' +
                        '<div>' +
                            '<input type="radio" name="help_target" class="update-click" id="' + uid_help_target_2 + '" value="window"><label for="' + uid_help_target_2 + '">Open link in a new browser tab</label>' +
                        '</div>' +
                    '</div>' : '') +
                '</div>' +
            '</div>' +
        '</div>';

        return html;
    },

    sortable: function() {
        new Sortable(this.$el.find('.sortable-container-main').get(0), {
            ghostClass: 'drag-placeholder',
            handle: '.drag-handle',
            animation: 200,
            onSort: () => {
                this.updateWidgetSettings();
            }
        });
    },

    render: function() {
        var screenshot_on       = this.model.get('workflow_type').indexOf('capture')         !== -1;
        var video_on            = this.model.get('workflow_type').indexOf('video')           !== -1;
        var bug_on              = this.model.get('workflow_type').indexOf('bug')             !== -1;
        var feature_request_on  = this.model.get('workflow_type').indexOf('feature_request') !== -1;
        var general_on          = this.model.get('workflow_type').indexOf('general')         !== -1;
        var portal_on           = this.model.get('workflow_type').indexOf('portal')          !== -1;
        var roadmap_on          = this.model.get('workflow_type').indexOf('roadmap')         !== -1;
        var announcement_on     = this.model.get('workflow_type').indexOf('announcement')  !== -1;
        var display_feedback_on = this.model.get('display_feedback') ? true : false;
        var help_on             = this.model.get('help_link')        ? true : false;
        var ai_on               = this.model.get('ai_feedback_type') ? true : false;

        var uid_bug                  = _.uniqueId(this.cid);
        var uid_general              = _.uniqueId(this.cid);
        var uid_feature_request      = _.uniqueId(this.cid);
        var uid_type_empty           = _.uniqueId(this.cid);
        var uid_type_bug             = _.uniqueId(this.cid);
        var uid_type_general         = _.uniqueId(this.cid);
        var uid_type_feature_request = _.uniqueId(this.cid);

        var layout_items = {};

        if (this.model.isNextGen()) {
            layout_items.general         = this.getLayoutBox('feedback',         'Feedback',          Svg_Icon.feedback_general,         true,                'text_feedback', '',     false, false, false);
            layout_items.portal          = this.getLayoutBox('portal',           'Ideas Portal',      Svg_Icon.feedback_feature_request, portal_on,           'text_portal',   '',     false, false, true);
            layout_items.roadmap         = this.getLayoutBox('roadmap',          'Roadmap',           Svg_Icon.feedback_feature_request, roadmap_on,          'text_roadmap',  '',     false, false, true);
            layout_items.announcement    = this.getLayoutBox('announcement',     'Announcements',     Svg_Icon.feedback_feature_request, announcement_on,     'text_announcement', '', false, false, true);
        } else {
            layout_items.screenshot      = screenshot_on ? this.getLayoutBox('capture',          'Screenshot',        Svg_Icon.feedback_screenshot,     true,                 'text_screenshot',      'text_screenshot_help',      false, true, false) : '';
            layout_items.vdieo           = video_on      ? this.getLayoutBox('video',            'Video',             Svg_Icon.feedback_video,          true,                 'text_video',           'text_video_help',           false, true, false) : '';
            layout_items.bug             = this.getLayoutBox('bug',              'Feedback: Bug',     Svg_Icon.feedback_bug,             bug_on,              'text_report_bug',      'text_report_bug_help',      true,  false, true);
            layout_items.feature_request = this.getLayoutBox('feature_request',  'Feedback: Idea',    Svg_Icon.feedback_feature_request, feature_request_on,  'text_feature_request', 'text_feature_request_help', true,  false, true);
            layout_items.general         = this.getLayoutBox('general',          'Feedback: General', Svg_Icon.feedback_general,         general_on,          'text_general',         'text_general_help',         true,  false, true);
            layout_items.view_other      = this.getLayoutBox('view_other',       'Feedback List',     Svg_Icon.feedback_other,           display_feedback_on, 'text_view_other',      'text_view_other_help',      false, false, true);
        }

        layout_items.help                = this.getLayoutBox('help',             'Custom Link',       Svg_Icon.feedback_help,            help_on,             'help_title',           'help_message',              false, false, true);

        var item_order = this.model.get('routing_item_order').split(',');
        var routing_item_options = '';

        // TODO: still hard code this?
        if (this.model.isNextGen()) {
            item_order = ['general', 'portal', 'roadmap', 'announcement', 'help'];
        }

        _.each(layout_items, function(item, item_type) {
            if (item_order.indexOf(item_type) === -1) {
                routing_item_options += item;
            }
        });

        // missing fields from the saved routing_item_order
        item_order.forEach(function(item_type) {
            if (typeof layout_items[item_type]) {
                routing_item_options += (layout_items[item_type] || '');
            }
        });

        var components =
        '<div data-name="#components">' +
            (this.model.isNextGen() ?
            '' :
            '<div>Drag and drop items to change the order</div>' +
            '<div class="divider-12"></div>') +

            (this.model.isNextGen() ? '' :
            '<div class="layout-box layout-box-locked" data-val="header">' +
                '<div class="layout-box-heading' + (this.model.isNextGen() ? '' : ' layout-box-heading-indented') + '">' +
                    (this.model.isNextGen() ? '' :
                    '<div class="drag-handle">' +
                        '<i class="fas fa-thumbtack"></i>' +
                    '</div>') +
                    '<span>Header</span>' +
                    '<div class="flex-c">' +
                        (Cache.account.hasFeature('widget_branding') ? '' :
                        '<button type="button" class="account-upgrade tiny shiny"><span>UPGRADE</span></button>') +
                    '</div>' +
                '</div>' +
                '<div class="layout-box-content layout-box-content-single">' +
                    '<button type="button" class="logo-upload small tertiary fluid square text-align-left flex-between">' +
                        '<span><i class="fa-solid fa-upload"></i> Upload logo</span>' +
                        '<div class="logo-preview flex-c">' +
                            '<img height="16" src="' + this.model.escape('logo') +  '">' +
                            '<a href="#" class="logo-delete margin-left-12 text-info tooltip" data-title="Remove logo"><i class="fa-solid fa-circle-xmark"></i></a>' +
                        '</div>' +
                    '</button>' +
                    '<div class="text-info text-small text-align-right margin-top-4">Image height: ' + (this.model.isNextGen() ? '24px' : '36px') + '</div>' +
                    '<div class="divider-12"></div>' +
                    '<div>' +
                        '<input type="text" name="header_text" class="update-keyup solid compact" maxlength="' + (this.model.isNextGen() ? '50' : '200') + '" placeholder="Add a message">' +
                        '<div class="maxlength-help"></div>' +
                    '</div>' +
                '</div>' +
            '</div>') +

            '<div class="sortable-container-main">' +
                routing_item_options +
            '</div>' +

            '<hr>' +

            '<div class="flex-between-top">' +
                '<div>' +
                    '<div class="setting-title">Powered by Userback</div>' +
                    '<div><input type="checkbox" class="update-click" name="hide_powered_by" id="hide_powered_by" value="1"><label for="hide_powered_by">Hide "Powered by Userback"</label></div>' +
                '</div>' +
                '<div>' +
                    (this.canRemovePoweredBy() ? '' :
                    '<button type="button" class="account-upgrade tiny shiny"><span>UPGRADE</span></button>') +
                '</div>' +
            '</div>' +
        '</div>';

        var apperance =
        '<div data-name="#appearance">' +
            '<div class="setting-title">Colors</div>' +
            '<div class="setting-subtitle">Highlight Color</div>' +
            '<div>Used in buttons, links and more to highlight</div>' +
            '<div class="divider-12"></div>' +
            '<div>' +
                '<input type="text" class="update-keyup colour solid compact short" name="main_button_background_colour">' +
                '<div class="colour-indicator"></div>' +
            '</div>' +

            '<div class="divider-32"></div>' +

            '<div class="setting-subtitle">Complementary Color</div>' +
            '<div>Used in text and icons on the highlight color</div>' +
            '<div class="divider-12"></div>' +
            '<div>' +
                '<input type="text" class="update-keyup colour solid compact short" name="main_button_text_colour">' +
                '<div class="colour-indicator"></div>' +
            '</div>' +

            '<hr class="medium">' +

            '<div class="setting-title">Launcher</div>' +
            '<div class="setting-subtitle">Style</div>' +
            '<div class="radio-box-select radio-box-select-2">' +
                '<div class="radio-box radio-box-style" data-val="circle"></div>' +
                '<div class="radio-box radio-box-style" data-val="text"></div>' +
            '</div>' +

            '<div class="divider-24"></div>' +

            '<div class="setting-subtitle">Icon</div>' +
            '<input type="checkbox" id="widget_icon_0"><label for="widget_icon_0">Do not use an icon</label>' +
            '<div class="divider-12"></div>' +
            '<div class="radio-box-select radio-box-select-7">' +
                '<div class="radio-box radio-box-widget-icon" data-val="7">' + Svg_Icon.widget_pointer + '</div>' +
                '<div class="radio-box radio-box-widget-icon" data-val="1">' + Svg_Icon.widget_chat + '</div>' +
                '<div class="radio-box radio-box-widget-icon" data-val="6">' + Svg_Icon.widget_bug + '</div>' +
                '<div class="radio-box radio-box-widget-icon" data-val="5">' + Svg_Icon.widget_stars + '</div>' +
                '<div class="radio-box radio-box-widget-icon" data-val="2">' + Svg_Icon.widget_comment_smile + '</div>' +
                '<div class="radio-box radio-box-widget-icon" data-val="4">' + Svg_Icon.widget_question + '</div>' +
                '<div class="radio-box radio-box-widget-icon" data-val="99">' +
                    '<div class="icon-delete tooltip" data-title="Remove"><i class="fas fa-times"></i></div>' +
                    '<img class="icon-preview" src="' + this.model.escape('icon_url') + '">' +
                '</div>' +
            '</div>' +
            '<div class="divider-12"></div>' +
            '<button class="icon-upload small tertiary"><i class="fa-solid fa-upload"></i> Upload your own</button>' +
            (Cache.account.hasFeature('widget_branding') ? '' :
            '<button type="button" class="account-upgrade tiny shiny margin-left-8"><span>UPGRADE</span></button>') +

            '<div class="divider-24"></div>' +

            '<div class="setting-subtitle">Position</div>' +
            '<div>Select where the launcher will be displayed</div>' +
            '<div class="divider-12"></div>' +
            '<div class="radio-box-select radio-box-select-4">' +
                '<div class="radio-box radio-box-position" data-style="' + this.model.get('style') + '" data-val="w"></div>' +
                '<div class="radio-box radio-box-position" data-style="' + this.model.get('style') + '" data-val="e"></div>' +
                '<div class="radio-box radio-box-position" data-style="' + this.model.get('style') + '" data-val="sw"></div>' +
                '<div class="radio-box radio-box-position" data-style="' + this.model.get('style') + '" data-val="se"></div>' +
            '</div>' +

            '<div class="region-main-button-offset">' +
                '<div class="divider-16"></div>' +
                '<div class="input-short grid-6-6 grid-gap-12">' +
                    '<div class="region-launcher-offset-x">' +
                        '<div class="margin-bottom-12">Side spacing</div>' +
                        '<div class="flex-start">' +
                            '<input type="number" name="launcher_offset_x" min="-200" max="200" class="update-input solid compact">' +
                            '<span class="margin-left-4 text-info">px</span>' +
                        '</div>' +
                    '</div>' +
                    '<div class="region-launcher-offset-y">' +
                        '<div class="margin-bottom-12">Bottom spacing</div>' +
                        '<div class="flex-start">' +
                            '<input type="number" name="launcher_offset_y" min="-200" max="200" class="update-input solid compact">' +
                            '<span class="margin-left-4 text-info">px</span>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</div>' +

            '<div class="region-main-button-text">' +
                '<div class="divider-24"></div>' +
                '<div class="setting-subtitle">Text</div>' +
                '<div>Customize the launcher text (up to 30 characters)</div>' +
                '<div class="divider-12"></div>' +
                '<div class="input-short">' +
                    '<input type="text" name="main_button_text" class="update-keyup solid compact" maxlength="30" placeholder="Feedback">' +
                '</div>' +
            '</div>' +

            '<hr class="medium">' +

            '<div class="setting-title">Widget</div>' +
            '<div class="setting-subtitle">Position</div>' +
            '<div>Select where the widget will be displayed</div>' +
            '<div class="divider-12"></div>' +
            '<div>' +
                '<div><input type="radio" class="update-click" name="use_modal" value="0" id="use_modal_0"><label for="use_modal_0">Around the launcher</label></div>' +
                '<div class="divider-8"></div>' +
                '<div><input type="radio" class="update-click" name="use_modal" value="1" id="use_modal_1"><label for="use_modal_1">Center</label></div>' +
            '</div>' +
        '</div>';

        var more =
        '<div data-name="#more">' +
            // language
            '<div class="setting-title">Language</div>' +
            '<div><p>Select the default language to be used in the widget. They can still be customized in the component settings.</p></div>' +
            '<div class="divider-12"></div>' +

            '<div class="input-short">' +
                '<div class="button-dropdown button-dropdown-full" data-update="true">' +
                    '<button type="button" class="dropdown-select">' + this.language_code[this.model.get('language')] + '</button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select dropdown-language">' +
                        Object.keys(this.language_code).sort().map((code) => {
                            return '<li data-val="' + code + '"' + (this.model.get('language') === code ? ' class="selected"' : '') + '>' + this.language_code[code] + '</li>';
                        }).join('') +
                        '</ul>' +
                    '</div>' +
                '</div>' +
            '</div>' +

            '<hr class="medium">' +

            // media

            '<div class="setting-title">Media</div>' +
            '<div class="setting-subtitle">Automatically capture a screenshot</div>' +
            '<input type="radio" name="auto_screenshot" value="1" class="update-click" id="auto_screenshot_0"><label for="auto_screenshot_0">Yes</label>' +
            '<input type="radio" name="auto_screenshot" value="0" class="update-click" id="auto_screenshot_1"><label for="auto_screenshot_1">No</label>' +

            '<div class="divider-24"></div>' +

            '<div class="setting-subtitle">Screen Recording Max Length</div>' +
            '<input type="range" name="video_time" class="update-input full" min="60" max="300" step="60">' +
            '<div class="video-time-text">' +
                '<div data-val="60">1 min</div>' +
                '<div data-val="120">2 mins</div>' +
                '<div data-val="180">3 mins</div>' +
                '<div data-val="240">4 mins</div>' +
                '<div data-val="300">5 mins</div>' +
            '</div>' +

            '<hr class="medium">' +

            // tracking
            '<div class="flex-between-top">' +
                '<div class="setting-title">Tracking</div>' +
                '<div>' +
                    (Cache.account.hasFeature('session_recording') && Cache.account.hasFeature('console_log') ? '' :
                    '<button type="button" class="account-upgrade tiny shiny"><span>UPGRADE</span></button>') +
                '</div>' +
            '</div>' +

            '<div class="setting-subtitle">Session Replay</div>' +
            '<div>Include a replay of the reporter\'s session to add context to their feedback</div>' +
            '<div class="divider-12"></div>' +
            '<input type="radio" name="capture_session_recording" class="update-click" id="capture_session_recording_1" value="1"><label for="capture_session_recording_1">Yes</label>' +
            '<input type="radio" name="capture_session_recording" class="update-click" id="capture_session_recording_0" value="0"><label for="capture_session_recording_0">No</label>' +

            '<div class="divider-24"></div>' +

            '<div class="setting-subtitle">Dev Tools</div>' +
            '<div>Automatically capture browser console logs & network requests</div>' +
            '<div class="divider-12"></div>' +
            '<input type="checkbox" name="console_log_type" class="update-click" id="capture_console_1" value="log"><label for="capture_console_1">Log</label>' +
            '<input type="checkbox" name="console_log_type" class="update-click" id="capture_console_2" value="error"><label for="capture_console_2">Error</label>' +
            '<input type="checkbox" name="console_log_type" class="update-click" id="capture_console_3" value="warn"><label for="capture_console_3">Warning</label>' +
            '<input type="checkbox" name="console_log_type" class="update-click" id="capture_console_4" value="info"><label for="capture_console_4">Info</label>' +
            '<input type="checkbox" name="console_log_type" class="update-click" id="capture_console_5" value="debug"><label for="capture_console_5">Debug</label>' +
            '<input type="checkbox" name="console_log_type" class="update-click" id="capture_console_6" value="network"><label for="capture_console_6">Network Request</label>' +

            (Cache.account.hasFeature('browser_events') ?
            '<div class="divider-24"></div>' +

            '<div class="setting-subtitle">Event Tracking</div>' +
            '<div>Automatically capture a trail of browser events</div>' +
            '<div class="divider-12"></div>' +
            '<input type="radio" name="capture_event" class="update-click" id="capture_event_1" value="1"><label for="capture_event_1">Yes</label>' +
            '<input type="radio" name="capture_event" class="update-click" id="capture_event_0" value="0"><label for="capture_event_0">No</label>' : '') +

            '<hr class="medium">' +

            // security
            '<div>' +
                '<div class="flex-between-top">' +
                    '<div class="setting-title">Security</div>' +
                    (Cache.account.hasFeature('hcaptcha') ? '' :
                    '<button type="button" class="account-upgrade tiny shiny"><span>UPGRADE</span></button>') +
                '</div>' +
                '<div>' +
                    '<div class="setting-subtitle">hCaptcha</div>' +
                    '<div>Protects the userback form with hCaptcha</div>' +
                    '<div class="divider-12"></div>' +
                    '<input type="radio" name="use_hcaptcha" class="update-click" id="use_hcaptcha_1" value="1"><label for="use_hcaptcha_1">Yes</label>' +
                    '<input type="radio" name="use_hcaptcha" class="update-click" id="use_hcaptcha_0" value="0"><label for="use_hcaptcha_0">No</label>' +
                '</div>' +
            '</div>' +
        '</div>';

        var type =
        '<div data-name="#type">' +
            '<div class="setting-title">AI Assist</div>' +
            '<button class="ai-feedback-type-toggle float-right small ' + (ai_on ? 'switch-on' : 'switch-off') + '"' + (Cache.account.hasFeature('ai') ? '' : ' disabled') + '></button>' +
            '<div><p>Leverage AI to automatically classify user feedback as a bug, idea, or general feedback.</p></div>' +
            (Cache.account.hasFeature('ai') ? '' :

            (Cache.account.get('appsumo') ?
            '<div class="text-align-right"><button type="button" class="tiny shiny cursor-default"><span>Add-on coming soon</span></button></div>' :
            '<div class="text-align-right"><button type="button" class="account-upgrade tiny shiny"><span>UPGRADE</span></button></div>')

            ) +
            '<div class="divider-24"></div>' +
            '<div class="region-feedback-type-without-ai' + (ai_on ? ' disabled' : '') + '">' +
                '<div class="setting-subtitle">Configure without AI</div>' +
                '<div class="box-small-large">' +
                    '<div class="font-weight-semibold margin-bottom-12">Feedback Type</div>' +
                    '<div class="flex-start">' +
                        '<div style="width:90px;">' +
                            '<input type="checkbox" class="update-input" name="feedback_type" id="' + uid_bug + '" value="bug">' +
                            '<label for="' + uid_bug + '">Bug</label>' +
                        '</div>' +
                        '<div>' +
                            '<input type="text" class="update-keyup solid compact" name="text_feedback_type_bug" maxlength="30" placeholder="' + Lang.get('feedback_type_bug', true) + '">' +
                        '</div>' +
                    '</div>' +
                    '<div class="divider-12"></div>' +
                    '<div class="flex-start">' +
                        '<div style="width:90px;">' +
                            '<input type="checkbox" class="update-input" name="feedback_type" id="' + uid_feature_request + '" value="feature_request">' +
                            '<label for="' + uid_feature_request + '">Idea</label>' +
                        '</div>' +
                        '<div>' +
                            '<input type="text" class="update-keyup solid compact" name="text_feedback_type_feature_request" maxlength="30" placeholder="' + Lang.get('feedback_type_feature_request', true) + '">' +
                        '</div>' +
                    '</div>' +
                    '<div class="divider-12"></div>' +
                    '<div class="flex-start">' +
                        '<div style="width:90px;">' +
                            '<input type="checkbox" class="update-input" name="feedback_type" id="' + uid_general + '" value="general">' +
                            '<label for="' + uid_general + '">General</label>' +
                        '</div>' +
                        '<div>' +
                            '<input type="text" class="update-keyup solid compact" name="text_feedback_type_general" maxlength="30" placeholder="' + Lang.get('feedback_type_general', true) + '">' +
                        '</div>' +
                    '</div>' +
                    '<div class="font-weight-semibold margin-top-12">Default Value</div>' +
                    '<div class="margin-top-12 flex-start column-gap-8">' +
                        '<input type="radio" name="feedback_type_default" class="update-input" id="' + uid_type_empty + '" value=""' + (this.widget.get('feedback_type').split(',').length <= 1 ? ' disabled' : '') + '><label for="' + uid_type_empty + '">Select...</label>' +
                        '<input type="radio" name="feedback_type_default" class="update-input" id="' + uid_type_bug + '" value="bug"' + (this.widget.get('feedback_type').indexOf('bug') === -1 ? ' disabled' : '') + '><label for="' + uid_type_bug + '">Bug</label>' +
                        '<input type="radio" name="feedback_type_default" class="update-input" id="' + uid_type_feature_request + '" value="feature_request"' + (this.widget.get('feedback_type').indexOf('feature_request') === -1 ? ' disabled' : '') + '><label for="' + uid_type_feature_request + '">Idea</label>' +
                        '<input type="radio" name="feedback_type_default" class="update-input" id="' + uid_type_general + '" value="general"' + (this.widget.get('feedback_type').indexOf('general') === -1 ? ' disabled' : '') + '><label for="' + uid_type_general + '">General</label>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>';

        var feedback_form = '<div data-name="#feedback"></div>';

        var content =
        '<div class="region-widget-edit setting-content">' +
            '<div class="tab">' +
                '<div class="tab-menu tab-menu-main">' +
                    (this.model.isNextGen() ?
                    '<a href="#appearance">Appearance</a>' +
                    '<a href="#feedback">Form</a>' +
                    '<a href="#type">Feedback Types</a>' +
                    '<a href="#components">Components</a>' +
                    '<a href="#more">More</a>'

                    :

                    '<a href="#components">Components</a>' +
                    '<a href="#appearance">Appearance</a>' +
                    '<a href="#more">More</a>') +
                '</div>' +
                '<div class="tab-content tab-content-main">' +
                    (this.model.isNextGen() ?
                    apperance + feedback_form + type + components + more
                    :
                    components + apperance + more) +
                '</div>' +
            '</div>' +
        '</div>' +

        // form edit
        (this.model.isNextGen() ? '' :
        '<div class="region-form-edit">' +
            '<div class="action-bar">' +
                '<div>' +
                    '<button type="button" class="form-edit-cancel small text-info padding-left-0"><i class="fa-regular fa-angle-left"></i> Back</button>' +
                '</div>' +
                '<div class="form-type"></div>' +
            '</div>' +
        '</div>');

        this.$el.html(content);

        // render subviews
        var region_element = this.model.isNextGen() ? this.$el.find('.tab-content-main > div[data-name="#feedback"]') : this.$el.find('.region-form-edit');

        if (this.model.isNextGen()) {
            this.views.form_edit_general.render().$el.appendTo(region_element);
        } else {
            this.views.form_edit_bug.render().$el.appendTo(region_element);
            this.views.form_edit_general.render().$el.appendTo(region_element);
            this.views.form_edit_feature_request.render().$el.appendTo(region_element);
        }

        // selected tab
        this.$el.find('.tab-menu-main a[href="' + this.main_tab_selected + '"]').addClass('active');
        this.$el.find('.tab-content-main > div[data-name="' + this.main_tab_selected + '"]').addClass('active');

        // selected form edit
        if (this.form_selected) {
            this.$el.find('.layout-box[data-val="' + this.form_selected.replace('#form_', '') + '"] .form-edit').click();
        }

        // set form data
        var console_log_type = [];

        [
            'capture_console_log',
            'capture_console_error',
            'capture_console_warn',
            'capture_console_info',
            'capture_console_debug',
            'capture_network'
        ].forEach((type) => {
            if (this.model.get(type)) {
                console_log_type.push(type.replace('capture_console_', '').replace('capture_', ''));
            }
        });

        Form.setData(this.$el.find('.region-widget-edit'), {
            launcher_offset_x                  : this.model.get('launcher_offset_x'),
            launcher_offset_y                  : this.model.get('launcher_offset_y'),
            header_text                        : this.model.get('header_text'),
            use_modal                          : this.model.get('use_modal') ? 1 : 0,
            hide_powered_by                    : this.model.get('display_powered_by') ? [] : [1],
            main_button_text                   : this.model.get('main_button_text'),
            main_button_background_colour      : this.model.get('main_button_background_colour'),
            main_button_text_colour            : this.model.get('main_button_text_colour'),
            video_time                         : this.model.get('video_time'),
            console_log_type                   : console_log_type,
            capture_event                      : this.model.get('capture_event')   ? 1 : 0,
            use_hcaptcha                       : this.model.get('use_hcaptcha')    ? 1 : 0,
            auto_screenshot                    : this.model.get('auto_screenshot') ? 1 : 0,
            text_screenshot                    : this.model.get('text_screenshot'),
            text_screenshot_help               : this.model.get('text_screenshot_help'),
            text_video                         : this.model.get('text_video'),
            text_video_help                    : this.model.get('text_video_help'),
            text_report_bug                    : this.model.get('text_report_bug'),
            text_report_bug_help               : this.model.get('text_report_bug_help'),
            text_feature_request               : this.model.get('text_feature_request'),
            text_feature_request_help          : this.model.get('text_feature_request_help'),
            text_general                       : this.model.get('text_general'),
            text_general_help                  : this.model.get('text_general_help'),
            text_view_other                    : this.model.get('text_view_other'),
            text_view_other_help               : this.model.get('text_view_other_help'),
            help_title                         : this.model.get('help_title'),
            help_message                       : this.model.get('help_message'),
            help_link                          : this.model.get('help_link'),
            portal_target                      : this.model.get('portal_target'),
            roadmap_target                     : this.model.get('roadmap_target'),
            text_portal                        : this.model.get('text_portal'),
            text_roadmap                       : this.model.get('text_roadmap'),
            text_announcement                  : this.model.get('text_announcement'),
            announcement_target                : this.model.get('announcement_target'),
            help_target                        : this.model.get('help_target'),
            direct_to_portal                   : this.model.get('direct_to_feature_request') === 'portal' ? [1] : [],
            feedback_type                      : this.model.get('feedback_type').split(','),
            feedback_type_default              : this.model.get('feedback_type_default'),
            text_feedback_type_bug             : this.model.get('text_feedback_type_bug'),
            text_feedback_type_general         : this.model.get('text_feedback_type_general'),
            text_feedback_type_feature_request : this.model.get('text_feedback_type_feature_request'),
            capture_session_recording          : this.model.get('capture_session_recording') ? [1] : [0],

        });

        if (this.model.isNextGen()) {
            this.$el.find('.layout-box[data-val="capture"]').hide();
            this.$el.find('.layout-box[data-val="video"]').hide();
            this.$el.find('.layout-box[data-val="view_other"]').hide();
        }

        // powered by
        if (!this.canRemovePoweredBy()) {
            this.$el.find('[name=hide_powered_by]').prop('disabled', true);
        }

        if (!Cache.account.hasFeature('hcaptcha')) {
            this.$el.find('input[name="use_hcaptcha"]').prop('disabled', true);
        }

        if (!Cache.account.hasFeature('portal')) {
            this.$el.find('.layout-box[data-val="portal"] .form-toggle').prop('disabled', true);
            this.$el.find('.layout-box[data-val="roadmap"] .form-toggle').prop('disabled', true);
            this.$el.find('.layout-box[data-val="announcement"] .form-toggle').prop('disabled', true);
        }

        // logo
        if (!Cache.account.hasFeature('widget_branding')) {
            this.$el.find('.logo-upload').prop('disabled', true);
            this.$el.find('.icon-upload').prop('disabled', true);
        }

        if (!this.model.get('logo')) {
            this.$el.find('.logo-preview').hide();
        }

        if (!this.model.get('icon_url')) {
            this.$el.find('.radio-box-widget-icon[data-val="99"]').hide();
        }

        // widget style
        this.$el.find('.radio-box-style[data-val="' + this.model.get('style') + '"]').addClass('selected');

        // widget position
        this.$el.find('.radio-box-position[data-val="' + this.model.get('position') + '"]').addClass('selected');

        // widget icon
        if (this.model.get('icon') === 0) {
            this.$el.find('#widget_icon_0').prop('checked', true);
        } else {
            this.$el.find('.radio-box-widget-icon[data-val="' + this.model.get('icon') + '"]').addClass('selected');
        }

        this.$el.find('#widget_icon_0').prop('disabled', this.model.get('style') === 'circle');

        this.$el.find('.region-main-button-text').toggle(this.model.get('style') === 'text');

        // video time
        this.$el.find('.video-time-text > [data-val="' + this.model.get('video_time') + '"]').addClass('selected');

        // session recording
        if (!Cache.account.hasFeature('session_recording')) {
            this.$el.find('input[name="capture_session_recording"]').prop('disabled', true);
        }

        // tracking
        if (!Cache.account.hasFeature('console_log')) {
            this.$el.find('input[name="console_log_type"]').prop('disabled', true);
        }

        this.sortable();
        this.limitLauncherOffset();

        return this;
    }
});
